import { generatePath, PathParam } from "react-router-dom";

export const customGeneratePath = <Path extends string>(
  originalPath: Path,
  params?: Partial<{
    [key in PathParam<Path>]: unknown;
  }>,
): string => {
  const normalizedParams: {
    [key in PathParam<Path>]: string;
  } = {} as any;

  if (params) {
    Object.keys(params).forEach((key) => {
      const value = params[key];

      if (typeof value === "string" || typeof value === "number") {
        normalizedParams[key] = String(value);
      }
    });
  }

  return generatePath(originalPath, normalizedParams as any);
};
